import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';

function Navbar() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  console.log('Navbar render - isMobile:', isMobile, 'isMobileMenuOpen:', isMobileMenuOpen);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.mobile-nav') && !event.target.closest('.mobile-menu-toggle')) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    console.log('Hamburger clicked! Current state:', isMobileMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
    console.log('New state will be:', !isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" onClick={() => handleNavigation(ROUTES.home)} style={{ cursor: 'pointer' }}>
          <img
            src={`${process.env.PUBLIC_URL}/assest/img/buni logo.png`}
            alt="Buni"
            className="navbar-logo"
          />
        </div>
        
        {/* Desktop Navigation */}
        <div className="navbar-links">
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.home)}>Home</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.programs)}>Programs</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.successStories)}>Success Stories</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.space)}>Spaces</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.framework)}>Frameworks and Reports</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.mediaRelations)}>Media Relation</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.news)}>News</button>
          <button className="nav-link" onClick={() => handleNavigation(ROUTES.contact)}>Contact</button>
        </div>

        {/* Mobile Hamburger Menu */}
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu} style={{ 
          display: isMobile ? 'block' : 'none',
          border: '2px solid red' // Debug border
        }}>
          <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-nav active" style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          background: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div className="mobile-nav-content" style={{
            background: 'linear-gradient(135deg, #FF6347 0%, #FF6347 100%)',
            borderRadius: '20px',
            padding: '20px',
            maxWidth: '320px',
            width: '90%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
          }}>
            <div className="mobile-nav-header" style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              <h3 style={{ color: 'white', margin: 0, fontSize: '18px', fontWeight: 600 }}>Navigation</h3>
              <button className="mobile-nav-close" onClick={() => setIsMobileMenuOpen(false)} style={{
                background: 'rgba(255, 255, 255, 0.2)',
                border: 'none',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                color: 'white',
                fontSize: '20px',
                cursor: 'pointer'
              }}>
                ×
              </button>
            </div>
            <div className="mobile-nav-links">
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.home)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Home</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.programs)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Programs</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.successStories)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Success Stories</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.space)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Spaces</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.framework)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Frameworks and Reports</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.mediaRelations)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Media Relation</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.news)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>News</button>
              <button className="mobile-nav-link" onClick={() => handleNavigation(ROUTES.contact)} style={{
                display: 'block',
                width: '100%',
                padding: '16px 20px',
                margin: '8px 0',
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                color: 'white',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}>Contact</button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;


